import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/url-text-v1/url-text-v1-index';

@Injectable({
    providedIn: 'root'
})
export class UrlTextV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'url-text-v1';
    menuTitle: string = "URL";
    deprecated: boolean = false;


    /**
      * 
      * @param field the object data of the field
      * @returns UrlTextV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.UrlTextV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsUrlTextV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsUrlTextV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsUrlTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsUrlTextV1FieldComponent> {
        return fieldComponents.SettingsUrlTextV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillUrlTextV1FieldComponent> {
        return fieldComponents.FillUrlTextV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewUrlTextV1FieldComponent> {
        return fieldComponents.ViewUrlTextV1FieldComponent;
    }
}

